export default __webpack_public_path__ + "static/media/Books.6e5ef298.webp";